import React from "react";

const PrivacyPolicy = () => {
    return (
        <div style={{ padding: "40px", maxWidth: "960px", margin: "0 auto" }}>
            <h1>Chính Sách Bảo Mật</h1>
            <p><strong>Ngày hiệu lực:</strong> 21/08/2025</p>

            <h2>1. Mục đích thu thập thông tin</h2>
            <p>Chúng tôi thu thập thông tin cá nhân nhằm mục đích cải thiện trải nghiệm người dùng, cung cấp dịch vụ phù hợp, gửi thông báo và hỗ trợ kỹ thuật.</p>

            <h2>2. Các loại thông tin thu thập</h2>
            <ul>
                <li>Thông tin cá nhân: họ tên, email, số điện thoại, địa chỉ IP.</li>
                <li>Thông tin sử dụng: thời gian truy cập, trang đã xem, thao tác trên website.</li>
                <li>Cookie và công nghệ theo dõi: để lưu trạng thái đăng nhập và phân tích hành vi sử dụng.</li>
            </ul>

            <h2>3. Cách chúng tôi sử dụng thông tin</h2>
            <p>Thông tin được dùng để:
                <ul>
                    <li>Phân tích và cải tiến dịch vụ</li>
                    <li>Gửi thông báo hoặc email chăm sóc khách hàng</li>
                    <li>Đảm bảo bảo mật và ngăn chặn gian lận</li>
                </ul>
            </p>

            <h2>4. Chia sẻ thông tin</h2>
            <p>Chúng tôi không chia sẻ thông tin cá nhân của bạn với bên thứ ba ngoại trừ:
                <ul>
                    <li>Khi có sự đồng ý của bạn</li>
                    <li>Tuân thủ yêu cầu pháp lý</li>
                    <li>Các đối tác hỗ trợ vận hành website (đều có cam kết bảo mật)</li>
                </ul>
            </p>

            <h2>5. Bảo mật dữ liệu</h2>
            <p>Chúng tôi áp dụng các biện pháp bảo mật kỹ thuật và tổ chức để bảo vệ thông tin cá nhân của bạn khỏi truy cập trái phép, mất mát hoặc rò rỉ.</p>

            <h2>6. Quyền của bạn</h2>
            <p>Bạn có quyền yêu cầu truy cập, chỉnh sửa hoặc xóa thông tin cá nhân của mình bất kỳ lúc nào bằng cách liên hệ với chúng tôi.</p>

            <h2>7. Thay đổi chính sách</h2>
            <p>Chúng tôi có thể cập nhật chính sách bảo mật này bất kỳ lúc nào. Mọi thay đổi sẽ được công bố trên website.</p>

            <p>Nếu bạn có bất kỳ câu hỏi nào liên quan đến chính sách này, vui lòng liên hệ với chúng tôi qua email hoặc biểu mẫu liên hệ.</p>
        </div>
    );
};

export default PrivacyPolicy;
